export const instructionGuideSelector = state => state.instructionGuide;
